import React from 'react';
import ModuleReservation from '../components/ModuleReservation';

const VehiculesPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 to-gray-800">
      {/* Header */}
      <div className="bg-gradient-to-r from-[#0f172a] to-[#1e293b] text-white py-16 px-4 border-b-4 border-[#e2b13c]">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-5xl font-black mb-6 text-[#e2b13c]">
            Une Large Gamme de Véhicules Privés à votre Service
          </h1>
          <h2 className="text-2xl font-semibold mb-8 text-gray-200">
            L'élégance de la Berline et l'espace du Van 8 places
          </h2>
        </div>
      </div>

      {/* Véhicules */}
      <div className="max-w-6xl mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {/* Berline */}
          <div className="bg-[#0f172a] border-2 border-[#e2b13c] rounded-lg overflow-hidden">
            <div className="bg-gradient-to-r from-[#e2b13c] to-[#d4a434] p-6">
              <h3 className="text-3xl font-black text-[#0f172a] text-center">SKODA SUPERB</h3>
              <p className="text-center text-[#0f172a] font-semibold mt-2">Berline Premium</p>
            </div>
            
            {/* Photo réelle de la Skoda Superb */}
            <div className="relative h-64 overflow-hidden">
              <img 
                src="/images/skoda-superb.jpg" 
                alt="Skoda Superb - Berline VTC des Weppes" 
                className="w-full h-full object-cover"
              />
            </div>
            
            <div className="p-8">
              <p className="text-gray-200 text-lg mb-6 leading-relaxed">
                L'élégance et le confort absolu pour vos déplacements d'affaires ou personnels.
              </p>
              <div className="space-y-3 text-gray-300">
                <div className="flex items-center justify-between bg-[#1e293b] p-3 rounded">
                  <span className="font-semibold">👥 Passagers</span>
                  <span className="text-[#e2b13c] font-bold">3 max</span>
                </div>
                <div className="flex items-center justify-between bg-[#1e293b] p-3 rounded">
                  <span className="font-semibold">🧳 Bagages</span>
                  <span className="text-[#e2b13c] font-bold">3 valises</span>
                </div>
                <div className="flex items-center justify-between bg-[#1e293b] p-3 rounded">
                  <span className="font-semibold">✨ Standing</span>
                  <span className="text-[#e2b13c] font-bold">Premium</span>
                </div>
              </div>
              <div className="mt-6 p-4 bg-gradient-to-r from-[#1e293b] to-[#0f172a] border border-[#e2b13c] rounded-lg">
                <p className="text-sm text-gray-300">
                  <strong className="text-[#e2b13c]">Equipements :</strong> Climatisation, Sièges cuir, WiFi, Chargeurs USB, Bouteilles d'eau
                </p>
              </div>
            </div>
          </div>

          {/* Van */}
          <div className="bg-[#0f172a] border-2 border-[#e2b13c] rounded-lg overflow-hidden">
            <div className="bg-gradient-to-r from-[#e2b13c] to-[#d4a434] p-6">
              <h3 className="text-3xl font-black text-[#0f172a] text-center">FORD TOURNEO CUSTOM</h3>
              <p className="text-center text-[#0f172a] font-semibold mt-2">Van 8 Places</p>
            </div>
            
            {/* Photo réelle du Ford Tourneo */}
            <div className="relative h-64 overflow-hidden">
              <img 
                src="/images/ford-tourneo-custom.jpg" 
                alt="Ford Tourneo Custom - Van VTC des Weppes" 
                className="w-full h-full object-cover"
              />
            </div>
            
            <div className="p-8">
              <p className="text-gray-200 text-lg mb-6 leading-relaxed">
                Idéal pour les familles, les groupes ou les séminaires d'entreprise.
              </p>
              <div className="space-y-3 text-gray-300">
                <div className="flex items-center justify-between bg-[#1e293b] p-3 rounded">
                  <span className="font-semibold">👥 Passagers</span>
                  <span className="text-[#e2b13c] font-bold">8 max</span>
                </div>
                <div className="flex items-center justify-between bg-[#1e293b] p-3 rounded">
                  <span className="font-semibold">🧳 Bagages</span>
                  <span className="text-[#e2b13c] font-bold">8 valises</span>
                </div>
                <div className="flex items-center justify-between bg-[#1e293b] p-3 rounded">
                  <span className="font-semibold">🚀 Usage</span>
                  <span className="text-[#e2b13c] font-bold">Groupes</span>
                </div>
              </div>
              <div className="mt-6 p-4 bg-gradient-to-r from-[#1e293b] to-[#0f172a] border border-[#e2b13c] rounded-lg">
                <p className="text-sm text-gray-300">
                  <strong className="text-[#e2b13c]">Equipements :</strong> Climatisation multi-zones, Espace modulable, WiFi, Chargeurs, Confort optimal
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Note importante */}
        <div className="mt-12 bg-[#1e293b] border-l-4 border-[#e2b13c] p-6 rounded">
          <p className="text-gray-300 text-lg">
            <strong className="text-[#e2b13c]">ℹ️ Bon à savoir :</strong> Le choix du véhicule se fait automatiquement en fonction du nombre de passagers et de bagages. Pour 4 passagers et plus, le Van est automatiquement attribué.
          </p>
        </div>

        {/* Photo de la flotte complète */}
        <div className="mt-12 bg-[#0f172a] border-2 border-[#e2b13c] rounded-lg overflow-hidden">
          <div className="bg-gradient-to-r from-[#e2b13c] to-[#d4a434] p-4">
            <h3 className="text-2xl font-black text-[#0f172a] text-center">NOTRE FLOTTE COMPLÈTE</h3>
            <p className="text-center text-[#0f172a] font-semibold mt-1">Toyota Hybride + 3 Vans Renault</p>
          </div>
          <div className="relative h-96">
            <img 
              src="/images/flotte-4-vehicules-complet.jpg" 
              alt="Flotte VTC des Weppes - 4 Véhicules Premium (Toyota + Renault)" 
              className="w-full h-full object-cover"
            />
          </div>
          <div className="p-6 text-center">
            <p className="text-gray-300 text-lg">
              Une flotte de <strong className="text-[#e2b13c]">4 véhicules premium</strong> entretenus avec le plus grand soin pour votre confort et votre sécurité.
            </p>
            <p className="text-gray-400 text-sm mt-3">
              Toyota hybride écologique + 3 Vans Renault spacieux pour tous vos besoins
            </p>
          </div>
        </div>
      </div>

      {/* Module de Réservation (MÊME QUE PAGE D'ACCUEIL) */}
      <div className="py-16 px-4">
        <ModuleReservation />
      </div>
    </div>
  );
};

export default VehiculesPage;